import React, { useState, Fragment } from 'react';
import { get, post } from "../Services/http";
import button from "./Button";
import { useSelector, useDispatch } from 'react-redux';
import { Menu, Transition } from '@headlessui/react';
import { translate } from "../Services/translation";

function CountrySelector() {
    const open = useSelector((state) => state.countryPicker.isOpen);
    const countryCode = useSelector((state) => state.countryPicker.countryCode);
    const countries = useSelector((state) => state.countryPicker.countries);
    const active = useSelector((state) => state.countryPicker.active);

    function selectCountry(country) {
        post('/api/countries', {
            country: country
        }).then(() => {
            window.location.reload()
        })
    }

    if (!active) {
        return null;
    }

    return (<div className="country-selector__wrapper">
        <Menu as="div" className="country-selector__menu">
            {({ open }) => (
                <>
                    <div>
                        <Menu.Button className="country-selector__button">
                            {translate(`countryselector.${countryCode}`.toLowerCase())}
                            <svg className={"country-selector__arrow" + (open ? " country-selector__arrow--open" : "")}
                                 width="20" height="21" viewBox="0 0 20 21" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g id="chevron-down">
                                    <path id="Vector" d="M5 7.68945L10 12.6895L15 7.68945"
                                          stroke="var(--top-bar-text, #fff)"
                                          strokeWidth="2"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                </g>
                            </svg>

                        </Menu.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        enter="country-selector__transition--enter"
                        enterFrom="country-selector__transition--enter-from"
                        enterTo="country-selector__transition--enter-to"
                        leave="country-selector__transition--leave"
                        leaveFrom="country-selector__transition--leave-from"
                        leaveTo="country-selector__transition--leave-to"
                    >
                        <Menu.Items className="country-selector__items">
                            <div className="country-selector__items-content">
                                {countries.map((x, index) => (
                                    <Menu.Item key={index}>
                                        {({ active }) => (
                                            <button
                                                onClick={() => selectCountry(x.code)}
                                                className={`country-selector__item-button ${active ? 'country-selector__item-button--active' : ''}`}
                                            >
                                                {translate(`countryselector.list.${x.code.toLowerCase()}`)}
                                            </button>
                                        )}
                                    </Menu.Item>
                                ))}
                            </div>
                        </Menu.Items>
                    </Transition>
                </>
            )}
        </Menu>
    </div>)
}

export default CountrySelector;
